import React from "react";
import styled from "styled-components";

const About = () => {
  return (
    <Wrapper id="about" name="about">
      <h2 className="main-heading">About Us</h2>
      <div className="content">
        <div className="text">
          <p>
            At MShine Enterprises, we are committed to producing premium-quality
            AdBlue and coolant products for diesel engines, ensuring optimal
            performance while reducing pollution. Our mission is to contribute
            to a cleaner, greener environment with products that offer Purity,
            Surety, and Quality at affordable prices.
          </p>
          <p>
            Guided by our visionary leader Mr. Suhan Raj, a dynamic entrepreneur, automobile
            engineer, and environmentalist, MShine Enterprises draws on the
            legacy of the Mahadevi Transport Group, a trusted name since 1979.
            With decades of experience, MShine continues to innovate under Mr.
            Suhan's forward-thinking leadership. His passion for sustainability
            and modern solutions drives the company toward a cleaner, greener
            future while upholding the trust and reliability of our parent
            group.
          </p>
          <p>
            Trust MShine Enterprises for all your AdBlue and coolant needs, and
            experience the reliability of world-class products backed by a
            legacy of leadership and a commitment to sustainability.
          </p>
        </div>
        <div className="image">
          <img
            src={`${process.env.PUBLIC_URL}/owner.png`}
            className="trophy"
            alt="..."
          />
        </div>
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  /* background: linear-gradient(to right, #f0f0f0, #fff); */
  padding: 4rem 2rem;
  font-family: Arial, sans-serif;

  .main-heading {
    position: relative;
    text-align: center;
  }

  .content {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    max-width: 1200px;
    margin: 0 auto;
  }

  .text {
    flex: 1;
    margin-right: 2rem;
    text-align: left;
    width: 60%;
  }
  .image {
    width: 30%;
  }

  h2 {
    font-size: 2.5rem;
    margin-bottom: 1.5rem;
    color: #333;
    text-transform: uppercase;
    font-family: "Play", sans-serif;
    font-optical-sizing: auto;
    font-weight: 900;
    font-style: italic;
  }

  p {
    font-size: 1rem;
    line-height: 1.6;
    margin-bottom: 1.5rem;
    color: #666;
  }

  strong {
    color: #000;
    font-weight: bold;
  }

  .image img {
    max-width: 100%;
    height: auto;
    max-height: 400px;
    /* border-radius: 50%; */
  }

  @media (max-width: 768px) {
    .content {
      flex-direction: column;
    }

    .text {
      margin-right: 0;
      text-align: center;
      width: 100%;
    }

    h2 {
      font-size: 2rem;
    }

    p {
      font-size: 1rem;
    }

    .image {
      margin-top: 2rem;
    }
  }
`;

export default About;
